document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector(".testimonials-vertical");
  if (!section) return;

  const items = section.querySelectorAll(".testimonial-item");
  const dots  = section.querySelectorAll(".dot");
  if (items.length < 2) return;

  const interval =
    Number(section.dataset.interval) ||
    Number(section.getAttribute("data-interval")) ||
    6000;

  let current = 0;

  setInterval(() => {
    const next = (current + 1) % items.length;

    items[current].classList.remove("is-active");
    items[current].classList.add("is-exit");

    items[next].classList.add("is-active");
    items[next].classList.remove("is-exit");

    dots[current]?.classList.remove("is-active");
    dots[next]?.classList.add("is-active");

    current = next;
  }, interval);
});
